import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { currentTzDate } from 'Data/format.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })
  let time_zone_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.time_zone_id',
  })

  return () => {
    submit({
      type: 'appointmentOverlay/open',
      mode: 'emergency',
      appointment_id: null,
      date: currentTzDate(time_zone_id),
    })
  }
}
